module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6ernV"))).then(() => parcelRequire('hEqeo'));